import React from 'react'

import IconTwitter from '../icons/twitter.svg'
import IconFacebook from '../icons/facebook.svg'
import IconInstagram from '../icons/instagram.svg'
import IconDribbble from '../icons/dribbble.svg'
import IconBehance from '../icons/behance.svg'

export default ({ socialLinks }) => (
	<div className="social-icons-wrap">
		<ul className="social-icons">
			{socialLinks.twitter && (
				<li>
					<a href={socialLinks.twitter} aria-label="Twitter">
						<IconTwitter />
					</a>
				</li>
			)}
			{socialLinks.facebook && (
				<li>
					<a href={socialLinks.facebook} aria-label="Facebook">
						<IconFacebook />
					</a>
				</li>
			)}
			{socialLinks.instagram && (
				<li>
					<a href={socialLinks.instagram} aria-label="Instagram">
						<IconInstagram />
					</a>
				</li>
			)}
			{socialLinks.dribbble && (
				<li>
					<a href={socialLinks.dribbble} aria-label="Dribbble">
						<IconDribbble />
					</a>
				</li>
			)}
			{socialLinks.behance && (
				<li>
					<a href={socialLinks.behance} aria-label="Behance">
						<IconBehance />
					</a>
				</li>
			)}
		</ul>
	</div>
)
